import { OfferType } from '../../../common/enums.js';
import { ProductOfferingsCardsByOfferTypeCoCo } from '../../../components/OrderSubscriptionSelection/ProductOfferingsCardsByOfferTypeCoCo.js';
import { PublicSoftwareProductsHeader } from '../../../components/PublicSoftwareProductsHeader/PublicSoftwareProductsHeader.js';
import '../../../components/PublicSoftwareProductsHeader/PublicSoftwareProductsHeader.scss';

export const PublicSoftwareProductsPath = () => {
  return (
    <section className="of-public-software-product-header of-public-page">
      <PublicSoftwareProductsHeader />
      <ProductOfferingsCardsByOfferTypeCoCo offerType={OfferType.SOFTWARE} publicPages />
    </section>
  );
};
